<form [formGroup]="addressForm" (ngSubmit)="addressForm.valid && onSubmit()" class="pd-30 h100" fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="30px">
    <h3 class="rm-margin" fxFlexAlign="center">
        {{"ENTER_DIFFERENT_ADDRESS" | translate}}
    </h3>

    <div fxLayout="column">
        <!-- COUNTRY -->
        <mat-form-field appearance="outline">
            <mat-label>{{ "COUNTRY" | translate }}</mat-label>
            <mat-select formControlName="country">
                <mat-option *ngFor="let country of countries | async" [value]="country.englishName">{{ country.otherName }}
                </mat-option>
            </mat-select>
        </mat-form-field>


        <!-- STATE -->
        <mat-form-field appearance="outline">
            <mat-label>{{ "STATE" | translate }}</mat-label>
            <mat-select formControlName="state">
                <mat-option *ngFor="let state of states | async" [value]="state">{{ state }}
                </mat-option>
            </mat-select>
        </mat-form-field>

        <!-- CITY -->
        <mat-form-field appearance="outline">
            <mat-label>{{ "CITY" | translate }}</mat-label>
            <mat-select formControlName="city">
                <mat-option *ngFor="let city of cities | async" [value]="city">{{ city }}
                </mat-option>
            </mat-select>
        </mat-form-field>


        <div fxLayout="row" fxLayoutAlign="space-between start" fxLayoutGap="20px">
            <!-- NO -->
            <mat-form-field appearance="outline" fxFlex>
                <mat-label>{{ "NO" | translate }}</mat-label>
                <input formControlName="no" matInput [placeholder]="'NO' | translate" />
            </mat-form-field>
            <!-- POSTCODE -->
            <mat-form-field appearance="outline" fxFlex>
                <mat-label>{{ "POST_CODE" | translate }}</mat-label>
                <input formControlName="zipcode" matInput [placeholder]="'POST_CODE' | translate" />
            </mat-form-field>
        </div>


        <mat-form-field appearance="outline" fxFlexAlign="stretch">
            <mat-label>{{ "ADDRESS" | translate }}</mat-label>
            <textarea formControlName="address" matInput rows="4"></textarea>
        </mat-form-field>
    </div>

    <div fxFlex></div>

    <button mat-flat-button color="primary" class="my-button" type="submit">{{"CONTINUE" |
        translate}}</button>
</form>